import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from '../app.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  loginStatus: boolean
  constructor(private app: AppService, private router: Router) {
    this.checkLogin()
    }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.loginStatus) {
        return true;
      }

      else{
        this.router.navigateByUrl('/');
        return false;
      }
  }

  checkLogin(){
    this.app.loginObserverable().subscribe(data=>{
      this.loginStatus = data
    })
  }

  
}
